import { useEffect,  useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  X,
  Mail,
  UserCircle2,
  CalendarDays,
  IdCard,
  Copy,
  ChevronRight,
  Monitor,
  FileText,
  User,
  MailCheck,
  PhoneCall,
  Calendar,
  Plus,
  TimerIcon,
  BadgeDollarSign,
  MessageCircleCodeIcon,
  PhoneCallIcon,
  MessageCircle,
  Key,
  DollarSign,
  CheckCircle,
  ChartNoAxesCombined,
  PackageSearch,
  Send,
  ALargeSmall,
  User2,
  MailCheckIcon,
  EarthIcon,
  PackageSearchIcon,
  Package2,
  Calendar1Icon,
} from "lucide-react";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import CommentsSection from "../../../../../component/comment";
import { Alert, Snackbar } from "@mui/material";
import InvoiceQuickView from "../../../../../component/invoice/InvoiceQuickView";
import AddActivity from "../../../../../component/modals/add-activity";
import { PopupTimeline } from "../../../../../component/ui/timeline";
import { DynamicTable, FieldRow } from "../../../../../component/Popup-comp";
import Icon from "../../../../../component/icons/inner-pages-icons";

const tabs = [
  { key: "timeline", label: "Timeline", icon: <TimerIcon size={16} /> },
  { key: "summary", label: "Summary", icon: <User size={16} /> },
  // { key: "deal", label: "Deal", icon: <FileTextIcon size={16} /> },
  {
    key: "transactions",
    label: "Transactions",
    icon: <BadgeDollarSign size={16} />,
  },
  {
    key: "comments",
    label: "Comments",
    icon: <MessageCircleCodeIcon size={16} />,
  },
  { key: "call", label: "Calls", icon: <PhoneCallIcon size={16} /> },
  { key: "emails", label: "Emails", icon: <Mail size={16} /> },
  { key: "sms", label: "Sms", icon: <MessageCircle size={16} /> },
];

function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}







const statusColor = {
  completed: { background: "#E6F9F0", color: "#0F9D58" }, // emerald green
  on_hold: { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
  in_progress: { background: "#F3E8FF", color: "#9333EA" }, // violet
  revision: { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  "no answer update 2": { background: "#f3f4f6", color: "#374151" }, // cyan / teal
  "wrong number": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "call back": { background: "#fffbeb", color: "#78350f" }, // cyan / teal
  "not interested": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "do not contact": { background: "#f9fafb", color: "#374151" }, // cyan / teal
  duplicate: { background: "#ede9fe", color: "#5b21b6" },
};
export default function ProjectQuickView({
  open = true,
  onClose = () => { },
  data,
}) {
  const [lead, setLead] = useState({});
  const [activeTab, setActiveTab] = useState("timeline");
  const [status, setStatus] = useState(lead?.leadstatus);
  const containerRef = useRef(null);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(false);

  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const [alertData, setAlertData] = useState({ isShow: false });
  const [changeModal, setChangeModal] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [usersList, setUsers] = useState([]);
  const [invoiceProjectKey, setInvoiceProjectKey] = useState(null);

  const GetData = async (key) => {
    let apiData = JSON.stringify({
      projectkey: key,
    });

    try {
      let call = await apiCall({
        method: "get",
        url: `projects/get-project/${key}`,
        data: apiData,
      });
      let projectData = call?.project;

      console.log("ProjectData", projectData);
      setIsLoading(true);

      let activity = projectData?.recent_activity?.map((item) => {
        const dateObj = new Date(item.time);
        const formattedDate = dateObj
          .toISOString()
          .slice(0, 16)
          .replace("T", " ");
        // This gives "YYYY-MM-DD HH:MM"

        return {
          ts: formattedDate,
          text: item.data,
        };
      });

      const sdata = {
        projectkey: projectData?.projectkey,
        id: projectData?.projectid,
        invoiceId: projectData?.invoiceid,
        status: projectData?.status,
        payment: projectData?.payment,
        cost: projectData?.projectcost,
        start: projectData?.startdate,
        end: projectData?.enddate,
        brief: projectData?.projectbrief,
        rush: projectData?.rush,
        createdAt: projectData?.created_at,
        updatedAt: projectData?.updated_at,

        activities: projectData?.activities,

        customer: projectData?.customer_details,
        agent: projectData?.agent_details,
        support: projectData?.support_details,
        transactions: projectData?.transactions,
        comments: projectData?.comments,
        stats: projectData?.stats ?? [],
        invoice_details: projectData?.invoice_details ?? [],
        project_deals: projectData?.project_deals ?? [],
        package_details: projectData?.package_details ?? [],
      };

      setStatus(projectData?.status);
      setLead(sdata);
      setIsLoading(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key.toLowerCase() === "f" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        const el = document.getElementById("quickview-search");
        el?.focus();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);



  const onActivitySuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    GetData(lead?.projectkey);
    setShowActivityModal(false);
  };

  useEffect(() => {
    if (activeTab === "timeline") {
      GetData(data?.project_key || data?.projectkey || lead?.projectkey);
    }
  }, [activeTab, data]);

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };
  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  



  const T = {
    bg: "#EDE8E1",
    sidebar: "#1a1726",
    sidebarText: "rgba(255,255,255,0.45)",
    sidebarActive: "#FFFFFF",
    sidebarActiveBg: "rgba(99,102,241,0.15)",
    sidebarHover: "rgba(255,255,255,0.05)",
    sidebarAccent: "#818cf8",
    card: "#FFFFFF",
    cardBorder: "rgba(0,0,0,0.10)",
    cardHover: "#FAF8F6",
    text: "#1a1520",
    textSecondary: "#5c5466",
    textMuted: "#908892",
    border: "rgba(0,0,0,0.08)",
    accent: "#6366f1",
    accentLight: "#EEF0FF",
    accentText: "#4F46E5",
    inputBg: "#F3EFE9",
    inputBorder: "rgba(0,0,0,0.1)",
    modalBg: "#FFFFFF",
    rowHover: "#F5F1EC",
    selectedRow: "#EEEAFF",
    selectedBorder: "#6366f1",
    shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
    shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  };

  const css = {
    app: {
      display: "flex",
      height: "100vh",
      fontFamily: "'DM Sans', -apple-system, sans-serif",
      background: T.bg,
      color: T.text,
      overflow: "hidden",
    },
    sidebar: {
      width: 250,
      background: T.sidebar,
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      overflow: "hidden",
    },
    main: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    card: {
      background: T.card,
      border: `1px solid ${T.cardBorder}`,
      borderRadius: 12,
      padding: 16,
      boxShadow: T.shadow,
    },
    btn: {
      padding: "7px 14px",
      borderRadius: 8,
      border: `1px solid ${T.border}`,
      background: T.card,
      color: T.textSecondary,
      cursor: "pointer",
      fontSize: 13,
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontFamily: "inherit",
      transition: "all 0.15s",
      boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    },
    btnPrimary: {
      padding: "8px 18px",
      borderRadius: 8,
      border: "none",
      background: "linear-gradient(92deg,#0057FB 1.54%,#003495 114.12%)",
      color: "#fff",
      cursor: "pointer",
      fontSize: 13,
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontFamily: "inherit",
      boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
    },
    input: {
      background: T.inputBg,
      border: `1px solid ${T.inputBorder}`,
      borderRadius: 8,
      padding: "9px 12px",
      color: T.text,
      fontSize: 13,
      outline: "none",
      fontFamily: "inherit",
      width: "100%",
    },
    select: {
      background: T.inputBg,
      border: `1px solid ${T.inputBorder}`,
      borderRadius: 8,
      padding: "6px 12px",
      color: T.text,
      fontSize: 13,
      outline: "none",
      fontFamily: "inherit",
      cursor: "pointer",
    },
    badge: (color) => ({
      display: "inline-flex",
      alignItems: "center",
      padding: "3px 9px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color: color,
      letterSpacing: "0.3px",
    }),
    pill: (active) => ({
      padding: "5px 12px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: active ? 600 : 400,
      border: active
        ? "1px solid rgba(99,102,241,0.35)"
        : `1px solid ${T.border}`,
      background: active ? T.accentLight : T.card,
      color: active ? T.accentText : T.textMuted,
      cursor: "pointer",
      fontFamily: "inherit",
      boxShadow: active ? "none" : "0 1px 2px rgba(0,0,0,0.03)",
    }),
  };



  const activityIcon = (type) =>
    ({
      call: "phone",
      phone: "phone",
      email: "mail",
      sms: "sms",
      consultation: "consultation",
      default: "default",

      note: "note",
      meeting: "calendar",
      "follow-up": "calendar",
      followup: "calendar",
      stage: "arrowRight",
      voicemail: "mic",
      chat: "sms",
      comment: "sms",
      demo: "demo",
      messasge: "sms",
      presentation: "presentation",
      assign: "assign",
      unassign: "unassign",
      file: "file",
      brief: "brief",
    })[type] || "check";
  const activityColor = (type) =>
    ({
      call: "#3b82f6", // blue
      email: "#8b5cf6", // violet
      sms: "#06b6d4", // cyan
      consultation: "#f59e0b", // amber
      note: "#f59e0b", // amber
      meeting: "#10b981", // emerald
      stage: "#6366f1", // indigo
      "follow-up": "#6366f1", // indigo
      voicemail: "#ef4444", // red

      chat: "#0ea5e9", // sky blue
      presentation: "#14b8a6", // teal
      demo: "#a855f7", // purple
      default: "#a855f7", // purple
      messasge: "#f43f5e", // rose

      // remaining icons (added)
      phone: "#3b82f6", // blue
      comment: "#0ea5e9", // sky
      followup: "#6366f1", // indigo
      assign: "#22c55e", // green
      unassign: "#ef4444", // red
      file: "#eab308", // slate
      brief: "#eab308", // yellow
    })[type] || "#6b7280";


  const refreshLead = {
    id: lead?.id,
    leadName: "Collins",
    phone: lead?.customer?.phone,
    activities: [],
  };

  // const I = (name, size = 16) => (icons[name] ? icons[name](size) : null);

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  const fmtTime = (iso) =>
    new Date(iso).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  const fmtDateTime = (iso) => `${fmtDate(iso)} ${fmtTime(iso)}`;

  // const icons = {
  //   search: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <circle cx="11" cy="11" r="8" />
  //       <path d="m21 21-4.3-4.3" />
  //     </svg>
  //   ),
  //   check: (s = 16) => (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       stroke-width="2"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //       class="lucide lucide-check-check-icon lucide-check-check"
  //     >
  //       <path d="M18 6 7 17l-5-5" />
  //       <path d="m22 10-7.5 7.5L13 16" />
  //     </svg>
  //   ),
  //   phone: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  //     </svg>
  //   ),
  //   mail: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <rect width="20" height="16" x="2" y="4" rx="2" />
  //       <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  //     </svg>
  //   ),
  //   msg: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22z" />
  //     </svg>
  //   ),
  //   user: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
  //       <circle cx="12" cy="7" r="4" />
  //     </svg>
  //   ),
  //   users: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
  //       <circle cx="9" cy="7" r="4" />
  //       <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
  //       <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  //     </svg>
  //   ),
  //   plus: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M5 12h14" />
  //       <path d="M12 5v14" />
  //     </svg>
  //   ),
  //   clock: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <circle cx="12" cy="12" r="10" />
  //       <polyline points="12 6 12 12 16 14" />
  //     </svg>
  //   ),
  //   dollar: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <line x1="12" x2="12" y1="2" y2="22" />
  //       <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  //     </svg>
  //   ),
  //   chart: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M3 3v18h18" />
  //       <path d="m19 9-5 5-4-4-3 3" />
  //     </svg>
  //   ),
  //   bell: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
  //       <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  //     </svg>
  //   ),
  //   chevDown: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="m6 9 6 6 6-6" />
  //     </svg>
  //   ),
  //   chevRight: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="m9 18 6-6-6-6" />
  //     </svg>
  //   ),
  //   x: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M18 6 6 18" />
  //       <path d="m6 6 12 12" />
  //     </svg>
  //   ),
  //   check: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M20 6 9 17l-5-5" />
  //     </svg>
  //   ),
  //   edit: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
  //     </svg>
  //   ),
  //   trash: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M3 6h18" />
  //       <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
  //       <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  //     </svg>
  //   ),
  //   file: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
  //       <path d="M14 2v4a2 2 0 0 0 2 2h4" />
  //     </svg>
  //   ),
  //   star: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="currentColor"
  //       stroke="currentColor"
  //       strokeWidth="1"
  //     >
  //       <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  //     </svg>
  //   ),
  //   filter: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  //     </svg>
  //   ),
  //   grid: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <rect width="7" height="7" x="3" y="3" rx="1" />
  //       <rect width="7" height="7" x="14" y="3" rx="1" />
  //       <rect width="7" height="7" x="14" y="14" rx="1" />
  //       <rect width="7" height="7" x="3" y="14" rx="1" />
  //     </svg>
  //   ),
  //   list: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <line x1="8" x2="21" y1="6" y2="6" />
  //       <line x1="8" x2="21" y1="12" y2="12" />
  //       <line x1="8" x2="21" y1="18" y2="18" />
  //       <line x1="3" x2="3.01" y1="6" y2="6" />
  //       <line x1="3" x2="3.01" y1="12" y2="12" />
  //       <line x1="3" x2="3.01" y1="18" y2="18" />
  //     </svg>
  //   ),
  //   target: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <circle cx="12" cy="12" r="10" />
  //       <circle cx="12" cy="12" r="6" />
  //       <circle cx="12" cy="12" r="2" />
  //     </svg>
  //   ),
  //   refresh: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
  //       <path d="M21 3v5h-5" />
  //       <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
  //       <path d="M8 16H3v5" />
  //     </svg>
  //   ),
  //   tag: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
  //       <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
  //     </svg>
  //   ),
  //   play: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="currentColor"
  //       stroke="none"
  //     >
  //       <polygon points="6 3 20 12 6 21 6 3" />
  //     </svg>
  //   ),
  //   pause: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="currentColor"
  //       stroke="none"
  //     >
  //       <rect x="6" y="4" width="4" height="16" />
  //       <rect x="14" y="4" width="4" height="16" />
  //     </svg>
  //   ),
  //   mic: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
  //       <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
  //       <line x1="12" x2="12" y1="19" y2="22" />
  //     </svg>
  //   ),
  //   send: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="m22 2-7 20-4-9-9-4Z" />
  //       <path d="m22 2-11 11" />
  //     </svg>
  //   ),
  //   home: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  //       <polyline points="9 22 9 12 15 12 15 22" />
  //     </svg>
  //   ),
  //   settings: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
  //       <circle cx="12" cy="12" r="3" />
  //     </svg>
  //   ),
  //   arrowUp: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="m5 12 7-7 7 7" />
  //       <path d="M12 19V5" />
  //     </svg>
  //   ),
  //   arrowDown: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M12 5v14" />
  //       <path d="m19 12-7 7-7-7" />
  //     </svg>
  //   ),
  //   calendar: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <rect width="18" height="18" x="3" y="4" rx="2" />
  //       <line x1="16" x2="16" y1="2" y2="6" />
  //       <line x1="8" x2="8" y1="2" y2="6" />
  //       <line x1="3" x2="21" y1="10" y2="10" />
  //     </svg>
  //   ),
  //   link: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
  //       <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  //     </svg>
  //   ),
  //   box: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
  //       <path d="m3.3 7 8.7 5 8.7-5" />
  //       <path d="M12 22V12" />
  //     </svg>
  //   ),
  //   shield: (s = 16) => (
  //     <svg
  //       width={s}
  //       height={s}
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //     >
  //       <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
  //     </svg>
  //   ),
  //   default: (p) => (
  //     //     <svg {...p}>
  //     //   <circle cx="12" cy="12" r="3" />
  //     //   <path d="M12 3v3" />
  //     //   <path d="M12 18v3" />
  //     //   <path d="M3 12h3" />
  //     //   <path d="M18 12h3" />
  //     // </svg>
  //     <svg {...p}>
  //       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  //     </svg>
  //   ),
  // };

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 !pr-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.aside
              ref={containerRef}
              initial={{ x: 40, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 40, opacity: 0 }}
              transition={{ type: "spring", stiffness: 380, damping: 32 }}
              className="relative mt-0 mr-0 mb-auto ml-0 flex h-full p-[28px] pb-0 w-[810px] max-w-[98vw] flex-col overflow-hidden rounded-3xl rounded-r-none  border border-solid border-slate-200 bg-[#ffffff] shadow-xl"
              aria-modal
              role="dialog"
            >
              {isLoading ? (
                <>
                  {/* Header */}
                  <div className=" bg-white/90  backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                    <div className="flex flex-wrap items-center justify-between gap-3 w-full pb-4">
                      <div className="flex min-w-0 items-center gap-3">
                        <div className="flex items-center justify-center size-12  bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 rounded-full overflow-hidden">
                          <p className="capitalize font-semi-bold text-base text-black">
                            {lead?.customer?.name
                              ?.split(" ")
                              ?.map((n, i) => n.charAt(0))}
                          </p>
                        </div>
                        <div className="min-w-0">
                          <div className="flex items-center gap-2">
                            <h2 className="text-xl font-semibold text-slate-900">
                              {lead?.customer?.name}
                            </h2>

                            <div
                              className={`flex items-center gap-2 px-[9px] py-[3px] text-[11px] rounded-[6px] cursor-pointer transition-all duration-200
                                `}
                              style={
                                statusColor[status] || {
                                  background: "#f5f5f5",
                                  color: "#616161",
                                }
                              }
                            // ${statusColor[status] || "bg-gray-100 text-gray-600 border border-gray-200"}
                            >
                              {status
                                ? status
                                  ?.split("_")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")
                                : null}
                            </div>
                          </div>

                          <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
                            <span className="inline-flex items-center gap-1">
                              <MailCheck className="size-4" />{" "}
                              {lead?.customer?.email}
                            </span>

                            <span className="inline-flex items-center gap-1">
                              <PhoneCall className="size-4" />{" "}
                              {lead?.customer?.phone}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                          onClick={onClose}
                          aria-label="Close"
                        >
                          <X className="size-4" /> Exit
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Body */}
                  <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-hidden  pt-0 w-full">
                    {/* Left: main content */}
                    <div className="col-span-12 flex min-h-0 flex-col gap-4">
                      {/* Top stats */}

                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          // marginTop: 14,
                          flexWrap: "wrap",
                          textTransform: "capitalize"
                        }}
                      >
                        {lead?.stats?.map(
                          (ele, idx) =>
                            ele?.value !== "-" &&
                            ele?.value !== null && (
                              <div
                                style={{
                                  padding: "8px 14px",
                                  background: "#F3EFE9",
                                  borderRadius: 10,
                                  border: `1px solid rgba(0,0,0,0.08)`,
                                }}
                              >
                                <div style={{ fontSize: 10, color: "#908892" }}>
                                  {ele?.key?.includes("_")
                                    ? ele?.key
                                      ?.split("_")
                                      .map((word) => ` ${word}`)
                                    : ele?.key}
                                </div>
                                <div
                                  style={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    marginTop: 3,
                                    color: "#1a1520",
                                  }}
                                >
                                  {ele?.value}
                                </div>
                              </div>
                            ),
                        )}
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          className="inline-flex items-center gap-1.5 tracking-normal rounded-lg bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                          hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)] px-[18px] py-2 text-[13px] font-semibold text-white"
                          onClick={() => setShowActivityModal(true)}
                          aria-label="Close"
                        >
                          <Plus className="size-[14px]" /> Add Follow Up
                        </button>

                        <button
                          className="inline-flex items-center gap-1.5 rounded-lg border border-solid border-[rgba(0,0,0,0.1)] bg-[rgb(243,239,233)]  px-[18px] py-2 text-[13px] font-semibold text-[rgb(26,21,32)] hover:bg-slate-50"
                          onClick={() => {
                            if (lead?.invoice_details) {
                              setInvoicePopup(true);
                              setInvoiceData(lead?.invoice_details);
                            }
                          }}
                          aria-label="Close"
                        >
                          <FileText className="size-[14px]" /> View Invoice
                        </button>
                      </div>

                      {/* Tabs */}
                      <div className="border-y border-solid pt-1 border-slate-200 flex items-center justify-between gap-2">
                        <div className="flex flex-wrap items-center ">
                          {tabs?.map((t) => (
                            <button
                              key={t.key}
                              onClick={() => setActiveTab(t.key)}
                              className={classNames(
                                "flex items-center gap-[6px] px-[16px] py-[11px] text-[13px] font-normal border-b-2 transition-all duration-200",
                                activeTab === t.key
                                  ? "border-blue-600 text-blue-600 font-semibold"
                                  : "border-transparent text-slate-500 hover:text-slate-800",
                              )}
                            >
                              {t.icon}
                              {t.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="h-full overflow-auto rounded-2xl py-2">
                        

                        {activeTab === "timeline" && (
                          // <div className="px-2 w-full h-full rounded-md">
                          //   {lead?.activities?.map((act, i) => {
                          //     const config =
                          //       activityConfig[act.type] || activityConfig.note;
                          //     return (
                          //       <div
                          //         key={act.id}
                          //         style={{
                          //           display: "flex",
                          //           gap: 12,
                          //           marginBottom: 16,
                          //         }}
                          //       >
                          //         <div
                          //           style={{
                          //             display: "flex",
                          //             flexDirection: "column",
                          //             alignItems: "center",
                          //           }}
                          //         >
                          //           <div
                          //             style={{
                          //               width: 34,
                          //               height: 34,
                          //               borderRadius: "50%",
                          //               background:
                          //                 activityColor(
                          //                   act?.icon?.toLowerCase(),
                          //                 ) + "12",
                          //               display: "flex",
                          //               alignItems: "center",
                          //               justifyContent: "center",
                          //               color: activityColor(
                          //                 act?.icon?.toLowerCase(),
                          //               ),
                          //               flexShrink: 0,
                          //             }}
                          //           >
                          //             {I(
                          //               activityIcon(act?.icon?.toLowerCase()),
                          //               15,
                          //             )}
                          //           </div>
                          //           {i < lead.activities.length - 1 && (
                          //             <div
                          //               style={{
                          //                 width: 1,
                          //                 flex: 1,
                          //                 background: T.border,
                          //                 marginTop: 4,
                          //               }}
                          //             />
                          //           )}
                          //         </div>
                          //         <div style={{ flex: 1, paddingBottom: 4 }}>
                          //           <div
                          //             style={{
                          //               display: "flex",
                          //               justifyContent: "space-between",
                          //               alignItems: "center",
                          //               marginBottom: 2,
                          //             }}
                          //           >
                          //             <span
                          //               style={{
                          //                 fontSize: 13,
                          //                 fontWeight: 600,
                          //                 color: T.text,
                          //               }}
                          //               className="capitalize"
                          //             >
                          //               {act?.logcat}
                          //             </span>
                          //             <span
                          //               style={{
                          //                 fontSize: 11,
                          //                 color: T.textMuted,
                          //               }}
                          //             >
                          //               {act?.logtime}
                          //             </span>
                          //           </div>
                          //           <div
                          //             style={{
                          //               fontSize: 12,
                          //               color: T.textMuted,
                          //               marginBottom: 4,
                          //             }}
                          //           >
                          //             {act?.logtype} · {act?.user?.name} ·{" "}
                          //             {moment(
                          //               act?.logtime,
                          //               "DD-MMM-YYYY hh:mm:ss A",
                          //             ).fromNow()}
                          //           </div>
                          //           <div
                          //             style={{
                          //               fontSize: 12,
                          //               color: T.textSecondary,
                          //               lineHeight: 1.6,
                          //             }}
                          //           >
                          //             {act.log}
                          //           </div>
                          //         </div>
                          //       </div>
                          //     );
                          //   })}
                          //   {lead?.activities?.length === 0 && (
                          //     <div
                          //       style={{
                          //         textAlign: "center",
                          //         color: "#908892",
                          //         padding: 40,
                          //       }}
                          //     >
                          //       No activities logged yet
                          //     </div>
                          //   )}
                          // </div>
                          <PopupTimeline timeline={lead?.activities} />
                        )}

                        {activeTab === "summary" && (
                          // <div
                          //   style={{
                          //     display: "flex",
                          //     gap: 16,
                          //   }}
                          // >

                          //   <div style={css.card} className="flex-1">
                          //     <div
                          //       style={{
                          //         fontSize: 14,
                          //         fontWeight: 600,
                          //         color: T.text,
                          //         marginBottom: 12,
                          //       }}
                          //     >
                          //       Project Information
                          //     </div>
                          //     <div
                          //       style={{
                          //         display: "grid",
                          //         gridTemplateColumns: "120px 1fr",
                          //         gap: 10,
                          //         fontSize: 13,
                          //       }}
                          //     >
                          //       <span style={{ color: T.textMuted }}>
                          //         Customer Name:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.customer?.name || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Email:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.customer?.email || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Phone:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.customer?.phone || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Invoice ID:
                          //       </span>
                          //       <span
                          //         style={{ color: T.text, fontWeight: 500 }}
                          //       >
                          //         {lead?.invoiceId || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Cost:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {`$${lead?.cost} - ${lead?.payment}` || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Agent:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.agent?.name || "Not Assigned"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Support:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.support?.name || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Start Date:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.start ?? "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         End Date:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.end ?? "-"}
                          //       </span>
                          //     </div>
                          //   </div>


                          //   <div style={css.card}>
                          //     <div
                          //       style={{
                          //         fontSize: 14,
                          //         fontWeight: 600,
                          //         color: T.text,
                          //         marginBottom: 12,
                          //       }}
                          //     >
                          //       Deal Information
                          //     </div>
                          //     <div
                          //       style={{
                          //         display: "grid",
                          //         gridTemplateColumns: "120px 1fr",
                          //         gap: 10,
                          //         fontSize: 13,
                          //       }}
                          //     >
                          //       <span style={{ color: T.textMuted }}>
                          //         Deal Id:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.project_deals?.dealid || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Name:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.project_deals?.name || "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Product:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.project_deals?.product?.products ??
                          //           "-"}
                          //       </span>
                          //       <span style={{ color: T.textMuted }}>
                          //         Package:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.package_details?.packagename ?? "-"}
                          //       </span>

                          //       <span style={{ color: T.textMuted }}>
                          //         Time:
                          //       </span>
                          //       <span style={{ color: T.text }}>
                          //         {lead?.project_deals?.dealtime ?? "-"}
                          //       </span>
                          //     </div>
                          //   </div>
                          // </div>

                          <>
                            <div>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Project Information
                              </div>

                              <div className="grid gap-6 md:grid-cols-2 w-full px-[10px]">
                                <FieldRow
                                  label="Customer Name"
                                  value={lead?.customer?.name}
                                  LabelIcon={ALargeSmall}
                                />
                                <FieldRow
                                  label="Email"
                                  value={lead?.customer?.email}
                                  LabelIcon={Send}
                                  isCapitalize={false}
                                  isCopyable={true}
                                />

                                <FieldRow
                                  label="Phone"
                                  value={lead?.customer?.phone}
                                  LabelIcon={PhoneCall}
                                />
                                <FieldRow
                                  label="Invoice ID:"
                                  value={lead?.invoiceId || "-"}
                                  LabelIcon={PackageSearch}
                                />

                                <FieldRow
                                  label="Cost"
                                  value={`${lead?.cost} - ${lead?.payment}`}
                                  LabelIcon={DollarSign}
                                />
                                <FieldRow
                                  label="Agent"
                                  value={lead?.agent?.name}
                                  LabelIcon={UserCircle2}
                                />

                                <FieldRow
                                  label="Support"
                                  value={lead?.support?.name}
                                  LabelIcon={User2}
                                />

                                <FieldRow
                                  label="Start Date"
                                  value={lead?.start}
                                  LabelIcon={Calendar}
                                />

                                 <FieldRow
                                  label="End Date"
                                  value={lead?.end}
                                  LabelIcon={CalendarDays}
                                />

                           
                              </div>
                            </div>

                            <div className="mt-[12px]">
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Deal Information
                              </div>

                              <div className="grid gap-6 md:grid-cols-2 w-full px-[10px]">
                                <FieldRow
                                  label="ID"
                                  value={lead?.project_deals?.dealid}
                                  LabelIcon={MailCheckIcon}
                                />
                                <FieldRow
                                  label="Name"
                                  value={lead?.project_deals?.name || "-"}
                                  LabelIcon={EarthIcon}
                                />

                                <FieldRow
                                  label="Product"
                                  value={lead?.project_deals?.product?.products ??"-"}
                                  LabelIcon={PackageSearchIcon}
                                />
                                <FieldRow
                                  label="Package"
                                  value={lead?.package_details?.packagename ?? "-"}
                                  LabelIcon={Package2}
                                />

                                <FieldRow
                                  label="Time"
                                  value={lead?.project_deals?.dealtime ?? "-"}
                                  LabelIcon={Calendar1Icon}
                                />
                              </div>
                            </div>
                          </>
                        )}

                   

                        {activeTab === "transactions" && (
                          <DynamicTable
                            data={lead?.transactions}
                            rowKey="transactionid"
                            onRowClick={(row) => {
                              if (row?.projectkey) {
                                setInvoicePopup(true);
                                setInvoiceProjectKey(row?.projectkey)
                                setInvoiceData(row?.projectkey)
                              }
                            }}
                            columns={[
                              {
                                key: "transactionkey",
                                label: "Transaction Key",
                                icon: Key, // icon for header
                                copy: true,
                                render: (row) => row.transactionkey ?? "-",
                              },
                              {
                                key: "amount",
                                label: "Amount",
                                icon: DollarSign, // icon for header
                                render: (row) => `$${row.amount ?? "-"}`, // prepend $ sign
                              },
                              {
                                key: "transactiontime",
                                label: "Time",
                                icon: CheckCircle, // icon for header
                                render: (row) => row.transactiontime ?? "-",
                              },
                              {
                                key: "transactionstatus",
                                label: "Status",
                                icon: ChartNoAxesCombined, // icon for header
                                render: (row) => {
                                  const color =
                                    row.transactionstatus === "success"
                                      ? "green"
                                      : row.transactionstatus === "pending"
                                        ? "blue"
                                        : "red";

                                  return (
                                    <div
                                      className={`inline-flex items-center  gap-1 rounded-[6px]  px-[9px] py-[3px] text-xs font-medium ${color === "green"
                                          ? "bg-emerald-100 text-emerald-700"
                                          : color === "blue"
                                            ? "bg-blue-100 text-blue-700"
                                            : "bg-rose-100 text-rose-700"
                                        }`}
                                    >
                                      {row.transactionstatus ?? "-"}
                                    </div>
                                  );
                                },
                              },
                            ]}
                          />
                          // <div className="space-y-3">
                          //   {lead?.transactions?.map((txn) => (
                          //     <Field
                          //       key={txn?.transactionid}
                          //       label={txn?.transactiontime}
                          //       value={`$${txn?.amount}`}
                          //       icon={Briefcase}
                          //       endTag={true}
                          //       LastElement={() => (
                          //         <Chip
                          //           color={
                          //             txn.transactionstatus == "success"
                          //               ? "green"
                          //               : "red"
                          //           }
                          //         >
                          //           {txn.transactionstatus}
                          //         </Chip>
                          //       )}
                          //     />
                          //   ))}
                          // </div>
                        )}

                        {activeTab === "comments" && (
                          <>
                            <CommentsSection
                              type="project"
                              id={lead?.id}
                              apiBaseUrl="project"
                              setAlertData={setAlertData}
                            />
                          </>
                        )}

                        {activeTab === "call" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            <div style={css.card}>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Make a Call
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: 8,
                                  marginBottom: 16,
                                }}
                              >
                                <input
                                  style={{ ...css.input, flex: 1 }}
                                  value={refreshLead.phone}
                                  readOnly
                                />
                                <button style={css.btnPrimary}>
                                  {/* {I("phone", 14)} Call Now */}
                                 <Icon  name="phone" size={14}/> Call Now
                                </button>
                              </div>
                            </div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 8,
                              }}
                            >
                              Call History
                            </div>
                            {refreshLead.activities
                              .filter(
                                (a) =>
                                  a.type === "call" || a.type === "voicemail",
                              )
                              .map((call) => (
                                <div
                                  key={call.id}
                                  style={{
                                    ...css.card,
                                    display: "flex",
                                    gap: 12,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 34,
                                      height: 34,
                                      borderRadius: "50%",
                                      background:
                                        activityColor(call.type) + "12",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: activityColor(call.type),
                                      flexShrink: 0,
                                    }}
                                  >
                                    {/* {I(activityIcon(call.type), 15)} */}
                                     <Icon  name="call" size={15}/>
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: 2,
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: 13,
                                          fontWeight: 600,
                                          color: T.text,
                                        }}
                                      >
                                        {call.summary}
                                      </span>
                                      <span
                                        style={{
                                          fontSize: 11,
                                          color: T.textMuted,
                                        }}
                                      >
                                        {fmtDateTime(call.date)}
                                      </span>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        color: T.textMuted,
                                        marginBottom: 4,
                                      }}
                                    >
                                      {call.agent} · {call.duration}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        color: T.textSecondary,
                                      }}
                                    >
                                      {call.details}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            {refreshLead.activities.filter(
                              (a) =>
                                a.type === "call" || a.type === "voicemail",
                            ).length === 0 && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    color: T.textMuted,
                                    padding: 40,
                                  }}
                                >
                                  No call history
                                </div>
                              )}
                          </div>
                        )}

                        {activeTab === "emails" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            <div style={css.card}>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Compose Email
                              </div>
                              <input
                                placeholder="Subject..."
                                style={{ ...css.input, marginBottom: 8 }}
                              />
                              <textarea
                                placeholder="Type your email message..."
                                style={{
                                  ...css.input,
                                  minHeight: 120,
                                  resize: "vertical",
                                  marginBottom: 8,
                                }}
                              />
                              <button style={css.btnPrimary}>
                                {/* {I("send", 14)} Send Email */}
                                 <Icon  name="send" size={14}/> Send Email
                              </button>
                            </div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 8,
                              }}
                            >
                              Email History
                            </div>
                            {refreshLead.activities
                              .filter((a) => a.type === "email")
                              .map((email) => (
                                <div key={email.id} style={{ ...css.card }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: T.text,
                                      }}
                                    >
                                      {email.summary}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 11,
                                        color: T.textMuted,
                                      }}
                                    >
                                      {fmtDateTime(email.date)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: T.textMuted,
                                      marginBottom: 4,
                                    }}
                                  >
                                    From: {email.agent}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 13,
                                      color: T.textSecondary,
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {email.details}
                                  </div>
                                </div>
                              ))}
                            {refreshLead.activities.filter(
                              (a) => a.type === "email",
                            ).length === 0 && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    color: T.textMuted,
                                    padding: 40,
                                  }}
                                >
                                  No email history
                                </div>
                              )}
                          </div>
                        )}

                        {activeTab === "sms" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 12,
                            }}
                          >
                            <div style={css.card}>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: T.text,
                                  marginBottom: 12,
                                }}
                              >
                                Send SMS
                              </div>
                              <textarea
                                placeholder="Type your message..."
                                style={{
                                  ...css.input,
                                  minHeight: 80,
                                  resize: "vertical",
                                  marginBottom: 8,
                                }}
                              />
                              <button style={css.btnPrimary}>
                                {/* {I("send", 14)} Send SMS */}
                                 <Icon  name="send" size={14}/> Send SMS
                              </button>
                            </div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 8,
                              }}
                            >
                              SMS History
                            </div>
                            {refreshLead.activities
                              .filter((a) => a.type === "sms")
                              .map((sms) => (
                                <div key={sms.id} style={{ ...css.card }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: T.text,
                                      }}
                                    >
                                      {sms.summary}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 11,
                                        color: T.textMuted,
                                      }}
                                    >
                                      {fmtDateTime(sms.date)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: T.textMuted,
                                      marginBottom: 4,
                                    }}
                                  >
                                    {sms.agent}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 13,
                                      color: T.textSecondary,
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {sms.details}
                                  </div>
                                </div>
                              ))}
                            {refreshLead.activities.filter(
                              (a) => a.type === "sms",
                            ).length === 0 && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    color: T.textMuted,
                                    padding: 40,
                                  }}
                                >
                                  No SMS history
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex items-center justify-between gap-2 border-t border-solid border-slate-200 bg-white p-3 w-full">
                    <div className="flex items-center gap-2 text-xs text-slate-500">
                      <IdCard className="size-4" /> ID {lead?.id}
                    </div>
                  </div>
                </>
              ) : (
                <InnerLoader wrapperClass={"w-full"} />
              )}
            </motion.aside>
          </motion.div>
        )}
      </AnimatePresence>

      {invoicePopup && invoiceData && (
        <InvoiceQuickView
          onClose={() => {
            setInvoicePopup(false);
            setInvoiceData(null);
            setInvoiceProjectKey(null)
          }}
          data={invoiceData}
          projectkey={invoiceProjectKey ? invoiceProjectKey : null}
          type="project"
        />
      )}



      {showActivityModal && (
        // <EmployeeDirectoryAddUpdate
        //   onClose={() => {
        //     setShowActivityModal(false);
        //   }}
        //   data={null}
        //   tabIndex={2}
        //   onError={onError}
        //   onSubmit={onSuccess}
        // id={lead?.id}
        // entitytype="project"
        // entityname={lead?.customer?.name}
        // />



        <AddActivity
          onSubmit={onActivitySuccess}
          onClose={() => {
            setShowActivityModal(false);
          }}
          onError={onError}
          UsersList={usersList}
          CustomerData={null}
          id={lead?.id}
          entitytype="project"
          entityname={lead?.customer?.name}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
}






